import RestResource from '../rest.service';

export default class DeliveryNoteItemsService extends RestResource {
  map(payload) {
    return {
      article_id: payload.article.id,
      quantity: payload.quantity,
    };
  }

  setDeliveryNote(deliveryNoteId) {
    this.parents = [];
    this.parents.push(deliveryNoteId);
    return this;
  }

  constructor() {
    super('delivery-notes/$0/items');
  }
}
